// extracted by mini-css-extract-plugin
export default {"loadingAssets":"LoadingAssets_loadingAssets__S0Bjv","top":"LoadingAssets_top__jF7Iz"};